module.exports = __webpack_public_path__ + "media/promo/velle/images/velleShare-eabbd96284dd2c8b6e9096c4dc8f8ac3.svg";